import { SET_KEYBOARD_AVAILABLE, SET_SCROLL_AVAILABLE } from '../constants/actionConstants';

// Updates store to reflect whether we are allowed to use keyboard (in comment box etc.)
const KeyboardReducer = (state = {keyboardAvailable: false, scrollAvailable: true}, action)=>{
    switch(action.type){
        case SET_KEYBOARD_AVAILABLE:
            return {...state, keyboardAvailable:action.payload.keyboardAvailable}
        case SET_SCROLL_AVAILABLE:
            // console.log(action.payload)
            return {...state, scrollAvailable:action.payload.scrollAvailable}
    
        default:
            return state ; 
    }
}

export default KeyboardReducer ; 

